import axios from '@/plugins/axios'

export default {

    get_services(params) {
        return axios.rasaApi.get(`/service`)
    },

}